<template>
  <section class="privacy-codebook">
    <div
      class="privacy-cloud-infor-mobile-background"
      :class="lang === 'zh' ? 'privacy-cloud-infor-mobile-background-zh' : ''"
    ></div>
    <div class="privacy-codebook-sticky" :class="vm.lang === 'zh' ? 'codebook-sticky' : 'separation-sticky'">
      <div class="text-intro codebook-text-intro">
        <p class="title" :class="topTextEnterScrollMagic ? 'textInPartMotion' : 'visibility-hidden'">
          {{ $t('codebook-title') }}
        </p>
        <p class="sub-title" :class="topTextEnterScrollMagic ? 'textInPartMotion' : 'visibility-hidden'">
          {{ $t('codebook-sub-title') }}
        </p>
        <p class="description" :class="topTextEnterScrollMagic ? 'textInPartMotion' : 'visibility-hidden'">
          {{ $t('codebook-description') }}
          <sup v-if="lang !== 'zh'">6</sup>
        </p>
      </div>
      <div
        class="separation-phone-container"
        :class="
          vm.isMobile && lang === 'zh'
            ? ''
            : (vm.isMobile
              ? phoneMobileEnterScrollMagic
              : topTextEnterScrollMagic)
            ? 'textInPartMotion'
            : 'visibility-hidden'
        "
      >
        <img
          v-lazy="
            require(`../../assets/${lang === 'zh' ? 'zh/' : ''}privacy/seperation-${
              vm.isMobile ? 'mobile-' : ''
            }phone-1.png`)
          "
          alt="ColorOS 11"
          class="separation-phone-img wow"
          :class="phoneActive ? 'separation-phone-figure__active' : ''"
          :style="{
            transform: lang === 'zh' ? phoneImgTransLeft : undefined
          }"
          data-wow-duration=".3s"
          data-wow-delay="1s"
          :data-wow-offset="100"
        />
        <div
          v-if="lang === 'zh'"
          class="codebook-icon-container wow"
          :class="vm.isMobile ? '' : topTextEnterScrollMagic ? 'textInPartMotion' : 'visibility-hidden'"
          data-wow-duration=".3s"
          data-wow-delay="1s"
          :data-wow-offset="100"
        >
          <img
            v-lazy="require(`../../assets/zh/privacy/codebook-icon-left.png`)"
            alt="ColorOS 11"
            class="codebook-icon-img"
            :style="{
              transform: vm.isMobile ? undefined : iconImgTransLeft
            }"
          />

          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :style="{
              opacity: vm.isMobile ? 1 : iconSvgOpacity
            }"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M30.5179 10.7132L29.1037 9.29899L19.6037 18.799L10.3047 9.5L8.89048 10.9142L18.1895 20.2132L9.30469 29.098L10.7189 30.5122L19.6037 21.6274L28.6895 30.7132L30.1037 29.299L21.0179 20.2132L30.5179 10.7132Z"
              fill="#FDFDFD"
            />
          </svg>

          <img
            v-lazy="require(`../../assets/zh/privacy/codebook-icon-right.png`)"
            alt="ColorOS 11"
            class="codebook-icon-img"
            :style="{
              transform: vm.isMobile ? undefined : iconImgTransRight,
              opacity: vm.isMobile ? undefined : iconImgOpacityRight
            }"
          />
        </div>
        <img
          v-lazy="
            require(`../../assets/${lang === 'zh' ? 'zh/' : ''}privacy/seperation-${
              vm.isMobile ? 'mobile-' : ''
            }phone-2.png`)
          "
          alt="ColorOS 11"
          class="separation-phone-img wow"
          :class="phoneActive ? 'separation-phone-figure__active' : ''"
          :style="{
            transform: lang === 'zh' && !vm.isMobile ? phoneImgTransRight : undefined,
            opacity: lang === 'zh' && !vm.isMobile ? phoneImgOpacityRight : undefined
          }"
          data-wow-duration=".3s"
          data-wow-delay="1s"
          :data-wow-offset="100"
        />
      </div>
    </div>
  </section>
</template>
<script>
import ScrollMagic from 'scrollmagic';
import Controller from '../../util/scrollMagic';
import UpdateAnimationMixin from '../../mixins/updateAnimation';

export default {
  inject: ['vm', 'lang'],
  mixins: [UpdateAnimationMixin],
  data() {
    return {
      zhProgress: 0,
      phoneActive: false,
      topTextEnterScrollMagic: false,
      phoneMobileEnterScrollMagic: false,
      iconImgTransLeft: 'translate3d(0, 0, 0)',
      iconSvgOpacity: 0,
      iconImgTransRight: 'translate3d(0, 0, 0)',
      iconImgOpacityRight: 0,
      phoneImgTransLeft: 'translate3d(0, 0, 0)',
      phoneImgOpacityRight: 0,
      phoneImgTransRight: 'translate3d(0, 0, 0)'
    };
  },
  watch: {
    zhProgress(value) {
      this.iconImgTransLeft = `translate3d(-${Math.min(104, (104 * value) / 0.4)}px, 0, 0)`;
      this.iconImgTransRight = `translate3d(${Math.min(104, (104 * value) / 0.4)}px, 0, 0)`;
      this.iconImgOpacityRight = Math.min(1, value / 0.4);
      this.iconSvgOpacity = Math.min(1, (value - 0.4) / 0.1);
      if (value <= 0.5) {
        this.phoneImgTransLeft = 'translate3d(0,0,0)';
        this.phoneImgTransRight = 'translate3d(0, 0, 0)';
        this.phoneImgOpacityRight = 0;
      } else {
        this.phoneImgTransLeft = `translate3d(-${Math.min(63, (63 * (value - 0.5)) / 0.5)}%, 0, 0)`;
        this.phoneImgTransRight = `translate3d(${Math.min(63, (63 * (value - 0.5)) / 0.5)}%, 0, 0)`;
        this.phoneImgOpacityRight = (value - 0.4) / 0.6;
      }
    }
  },
  mounted() {
    const topScene = new ScrollMagic.Scene({
      triggerElement: '.codebook-text-intro',
      triggerHook: this.vm.isMobile ? 1 : 0.5,
      offset: this.vm.isMobile ? 100 + 88 : 0
    })
      .addTo(Controller)
      .on('enter', () => {
        if (!this.topTextEnterScrollMagic) {
          this.topTextEnterScrollMagic = true;
        }
      });
    setTimeout(() => {
      if (topScene.progress() > 0) {
        this.topTextEnterScrollMagic = true;
      }
    }, 1000);
    this.resizeHandler();
    window.addEventListener('resize', this.resizeHandler);
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeHandler);
  },
  methods: {
    initScroll() {
      if (this.lang === 'zh') {
        this.scene = new ScrollMagic.Scene({
          triggerElement: '.privacy-codebook',
          triggerHook: 0,
          duration: window.innerHeight
        })
          .setPin('.codebook-sticky')
          .addTo(Controller)
          .on('progress', e => {
            this.updateBezier('zhProgress', e.progress, 100);
          });
      } else {
        this.scene = new ScrollMagic.Scene({
          triggerElement: '.separation-phone-img',
          triggerHook: 0,
          offset: -50
        })
          .addTo(Controller)
          .on('progress', e => {
            this.phoneActive = !!e.progress;
          });
      }
    },
    initScrollMobile() {
      if (this.lang === 'zh') {
        return;
      }
      this.sceneMobile = new ScrollMagic.Scene({
        triggerElement: '.codebook-text-intro',
        triggerHook: 0,
        offset: 50
      })
        .addTo(Controller)
        .on('progress', e => {
          this.phoneActive = !!e.progress;
        });

      new ScrollMagic.Scene({
        triggerElement: '.separation-phone-container',
        triggerHook: 1,
        offset: 100
      })
        .addTo(Controller)
        .on('enter', () => {
          if (!this.phoneMobileEnterScrollMagic) {
            this.phoneMobileEnterScrollMagic = true;
          }
        });
    },
    resizeHandler() {
      if (window.innerWidth <= 734) {
        if (this.scene) {
          this.scene.destroy(true);
          this.scene = null;
        }
        if (!this.sceneMobile) this.initScrollMobile();
        this.progress = 0;
      } else if (window.innerWidth > 734) {
        if (this.sceneMobile) {
          this.sceneMobile.destroy(true);
          this.sceneMobile = null;
        }
        if (!this.scene) this.initScroll();
      }
    }
  }
};
</script>
